module.exports = __webpack_public_path__ + "img/avatar6.49aa6248.png";